module.exports = __webpack_public_path__ + "r-v3/img/ml_06_00.736b68a0.jpg";